import React from 'react';
import { Autocomplete, TextField, FormHelperText, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { useUser } from '@/providers';

import STORAGE_TYPES from '@/components/jobs/JobForm/storageTypes';

export default function InputTypeField({ value, setValue, setChanged, edit }) {
  const user = useUser();
  const project_credentials = useSelector((state) => state.projectCredentials);

  const project_key_types = project_credentials
    ? project_credentials.map((key) => key.type)
    : [];

  const options = STORAGE_TYPES.input;

  const selectedOption =
    STORAGE_TYPES.input.find((type) => type.value === value) || null;

  const handleChange = (event, newValue) => {
    const newValueStr = newValue ? newValue.value : null;
    if (newValueStr !== value) {
      setChanged();
    }
    setValue(newValueStr);
  };

  const getOptionDisabled = (option) => {
    return !(
      option.alwaysEnabled ||
      project_key_types.includes(option.value) ||
      (option.cloudbender_required && user.cloudbender_enabled)
    );
  };

  return (
    <Box>
      <Autocomplete
        id='input_type'
        options={options}
        getOptionLabel={(option) => option.text}
        getOptionDisabled={getOptionDisabled}
        isOptionEqualToValue={(option, value) => option?.value === value?.value}
        value={selectedOption}
        onChange={handleChange}
        disabled={edit}
        renderInput={(params) => (
          <TextField
            {...params}
            label='Input Type'
            aria-describedby='input-type-helper-text'
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.value}>
            {option.text}
          </li>
        )}
      />
      <FormHelperText id='input-type-helper-text'>
        Select the input storage type
      </FormHelperText>
    </Box>
  );
}
